import { render, staticRenderFns } from "./FeatureCardRziDocuments.vue?vue&type=template&id=3c7043e0&"
import script from "./FeatureCardRziDocuments.vue?vue&type=script&lang=js&"
export * from "./FeatureCardRziDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports